import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Button, Icon } from 'antd'

// Số ngày lưu ảnh lệnh may (S3 lifecycle, K3)
const IMAGE_RETENTION_DAYS = 90

// Màn kết quả sau khi giao may thành công
const ResultView = ({ handover, onNew, onViewSlip }) => {
    const {
        code, partner_snapshot: partner, total_batches: totalBatches, total_quantity: totalQuantity,
        total_images: totalImages = totalBatches, handed_at: handedAt, handed_by: handedBy,
    } = handover
    const partnerName = (partner && partner.name) || ''

    return (
        <div className="HandoverResult">
            <Icon type="check" className="HandoverResult-icon" />
            <h2>Đã giao {totalBatches} lô{partnerName ? ` cho ${partnerName}` : ''}</h2>

            <dl className="HandoverResult-info">
                <dt>Số phiếu</dt>
                <dd className="HandoverResult-code">{code}</dd>
                <dt>Tổng item</dt>
                <dd>{totalQuantity}</dd>
                <dt>Người giao</dt>
                <dd>{(handedBy && handedBy.username) || '—'}</dd>
                <dt>Thời gian</dt>
                <dd>{handedAt ? moment(handedAt).format('HH:mm DD/MM/YYYY') : '—'}</dd>
            </dl>

            <div className="HandoverResult-note">
                Đã lưu {totalImages} ảnh lệnh may (giữ {IMAGE_RETENTION_DAYS} ngày). Nhóm may của đối tác chia ở màn Nhóm may như hiện tại.
            </div>

            <Button type="primary" size="large" block onClick={onViewSlip}>
                Xem phiếu xuất kho
            </Button>
            <Button size="large" block className="HandoverResult-new" onClick={onNew}>Giao lượt mới</Button>
        </div>
    )
}

ResultView.propTypes = {
    handover: PropTypes.object.isRequired,
    onNew: PropTypes.func.isRequired,
    // Mở phiếu xuất kho A4 (/sewing-handover/:id/print — T5)
    onViewSlip: PropTypes.func.isRequired,
}

export default ResultView
